export let CodeVerificationActionTypes;
(function (CodeVerificationActionTypes) {
  CodeVerificationActionTypes["Start"] = "[Code Verification] Start";
  CodeVerificationActionTypes["Success"] = "[Code Verification] Success";
  CodeVerificationActionTypes["Failed"] = "[Code Verification] Failed";
})(CodeVerificationActionTypes || (CodeVerificationActionTypes = {}));